/*
    SUMMARY
    0 - AUTO YEAR
    1 - REVEAL ANIMATION (mobile footer .rodape)
*/


export default function Footer() {

    /*-----------------/ 0 - Const / Variables /--------------------*/


    /*-----------------/ 1 - Function /--------------------*/


    /*-----------------/ 2 - AUTO YEAR /--------------------*/
    const currentYear = new Date().getFullYear()
    const yearElements = document.querySelectorAll('.auto--year')
    yearElements.forEach((el) => { el.innerHTML = currentYear })

    /*-----------------/ 3 - REVEAL ANIMATION (global footer .rodape) /--------------------*/
    const footerReveal = document.querySelector('#footer .rodape.js-reveal')
    if (footerReveal && 'IntersectionObserver' in window) {
        const obs = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    e.target.classList.add('visible')
                    obs.unobserve(e.target)
                }
            })
        }, { threshold: 0.05 })
        obs.observe(footerReveal)
    }
}
